import { Flex, Checkbox } from "@base-ui";
import { addRemoveListContent } from "utils/addRemoveListContent";
import { StyledCheckbox, GraphContainer } from "./stackedBarchart.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Legends(props) {
  var id = props.id,
    activePartitions = props.activePartitions,
    setActivePartitions = props.setActivePartitions,
    partitionKeys = props.partitionKeys,
    layers = props.layers,
    activeLayers = props.activeLayers,
    setActiveLayers = props.setActiveLayers;
  var layersMarkup = layers === null || layers === void 0 ? void 0 : layers.map(function (layer) {
    return /*#__PURE__*/_jsx(StyledCheckbox, {
      id: "".concat(id, "-").concat(layer.id),
      label: layer.name,
      color: layer.color,
      checked: activeLayers.includes(layer.id),
      onChange: function onChange(add) {
        return addRemoveListContent(setActiveLayers, null, add, layer.id);
      }
    }, layer.id);
  });
  var partitions = partitionKeys === null || partitionKeys === void 0 ? void 0 : partitionKeys.map(function (partition) {
    return /*#__PURE__*/_jsx(Checkbox, {
      id: "".concat(id, "-").concat(partition),
      label: partition,
      checked: activePartitions.includes(partition),
      onChange: function onChange(add) {
        return addRemoveListContent(setActivePartitions, null, add, partition);
      }
    }, partition);
  });
  return /*#__PURE__*/_jsxs(GraphContainer, {
    style: {
      display: "flex",
      margin: "0 0 0 auto"
    },
    children: [/*#__PURE__*/_jsx(Flex.Column, {
      children: layersMarkup
    }), /*#__PURE__*/_jsx(Flex.Column, {
      children: partitions
    })]
  });
}